import { createContext, useContext, useMemo, useState } from "react";

import Service from "../../api/service";

const CityContext = createContext(null);

export const useCityContext = () => {
  const v = useContext(CityContext);
  if (!v) {
    throw new Error("useCityContext must be used inside CityProvider");
  }
  return v;
};

const sortByPriority = (list = []) =>
  [...list].sort((a, b) => (b?.priority ?? 0) - (a?.priority ?? 0));

export const CityProvider = ({ children }) => {
  const [count, setCount] = useState(null);
  const [cities, setCities] = useState(null);

  const fetchCities = async (page, pageSize) => {
    const response = await Service.get(
      `/api/v1/admin/city/?page=${page}&pageSize=${pageSize}`,
    );
    const payload = response?.data;
    if (payload) {
      setCities(sortByPriority(payload.data));
      setCount(payload.count);
    }
    return response;
  };

  const addPriority = async ({ key, priority, id }) =>
    Service.post(
      `/api/v1/city/priority/set/?key=${key}&priority=${priority}&content_id=${id}`,
      {},
    );

  const updateCityStatus = async ({ id, level, currentStatus }) => {
    const nextStatus = currentStatus !== 1 ? 1 : 0;
    return Service.put(
      `api/v1/admin/city/status/?id=${id}&status=${nextStatus}&level=${level}`,
      {},
    );
  };

  const value = useMemo(
    () => ({
      count,
      cities,
      setCities,
      fetchCities,
      addPriority,
      updateCityStatus,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [count, cities],
  );

  return <CityContext.Provider value={value}>{children}</CityContext.Provider>;
};
